import type { SVGProps } from "react";
const SvgArrowUp01Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m5 12.5 4.41-4.41c.278-.279.417-.417.59-.417.172 0 .311.138.59.416L15 12.5"
    />
  </svg>
);
export default SvgArrowUp01Sharp;
